module.exports = __webpack_public_path__ + "img/img-bg-small.9e6695d6.png";